<iw-details-value
  label="withdrawal.cardPersonal.name.label"
  [value]="details.name"
/>
<iw-details-value
  label="withdrawal.cardPersonal.surname.label"
  [value]="details.surname"
/>
<iw-details-value
  label="withdrawal.cardPersonal.cardNumber.label"
  [value]="details.cardNumber | cardNumber"
/>
<iw-details-value
  label="withdrawal.cardPersonal.description.label"
  [value]="details.description"
/>
